(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/button-play.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/button-play.js');

'use strict';

const {
  useHistory
} = ReactRouterDOM;
const {
  trackClickPlayResult
} = svs.lyckoplatsen.page_result;
const Button = svs.ui.ReactButton;
const ButtonPlay = () => {
  const history = useHistory();
  const buttonLabel = 'Spela på din Lyckoplats';
  const handleClick = () => {
    trackClickPlayResult();
    history.push('/spela');
  };
  return React.createElement("div", {
    className: "lp-result-play lp-buttons"
  }, React.createElement("div", {
    className: "buttons-body margin-bottom-2"
  }, React.createElement(Button, {
    onClick: handleClick,
    transparent: true,
    block: true,
    size: 300
  }, buttonLabel)));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  ButtonPlay
});

 })(window);